import { render, staticRenderFns } from "./TheHeaderDropdownAccnt.vue?vue&type=template&id=90b9bf96&scoped=true"
import script from "./TheHeaderDropdownAccnt.vue?vue&type=script&lang=js"
export * from "./TheHeaderDropdownAccnt.vue?vue&type=script&lang=js"
import style0 from "./TheHeaderDropdownAccnt.vue?vue&type=style&index=0&id=90b9bf96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b9bf96",
  null
  
)

export default component.exports